import { useEffect, useState } from "react";
import { useDesignerStore } from "../store";
import { designerEngine } from "../engine/DesignerEngine";
import { colorsApi, type GarmentColor } from "@/lib/api";

// Garment-colour swatches. Tints the shirt preview only — placed artwork keeps
// its original colours. Colours are superadmin-managed (Admin → Colours).
export default function ColorPanel() {
  const product = useDesignerStore((s) => s.product);
  const garmentColor = useDesignerStore((s) => s.garmentColor);
  const [colors, setColors] = useState<GarmentColor[]>([]);

  useEffect(() => {
    colorsApi.get().then((r) => setColors(r.colors)).catch(() => {});
  }, []);

  if (product !== "tshirt") return null;

  return (
    <div className="rounded-xl bg-slate-800 border border-slate-700 p-4">
      <h3 className="text-lg font-bold text-white mb-3">🎨 Shirt colour</h3>
      <div className="grid grid-cols-6 gap-2">
        {colors.map((c) => {
          const active = garmentColor.toLowerCase() === c.hex.toLowerCase();
          return (
            <button
              key={c.hex}
              title={c.name}
              onClick={() => designerEngine.setGarmentColor(c.hex)}
              className={`h-8 w-full rounded-md border-2 transition ${
                active ? "border-cyan-400 ring-2 ring-cyan-400/40" : "border-slate-600 hover:border-slate-400"
              }`}
              style={{ backgroundColor: c.hex }}
            />
          );
        })}
      </div>
      <p className="text-slate-400 text-xs mt-2">Artwork colours stay exactly as designed.</p>
    </div>
  );
}
